/**
 * Google Analytics 4 (gtag.js) — loaded on app boot.
 * Consent Mode v2 defaults are set inline in index.html (analytics granted, ads denied).
 */

const GA_ID = "G-1YV290XVBM";
let scriptInjected = false;

function injectGtagScript(): void {
  if (scriptInjected || typeof document === "undefined") return;
  scriptInjected = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    // We send page_view manually via trackPageView() on each route change.
    window.gtag("config", GA_ID, { send_page_view: false });
  }
}

/** Inject GA on app boot. Safe to call multiple times. */
export function initGA(): void {
  if (typeof window === "undefined") return;
  injectGtagScript();
}

export function grantAnalyticsConsent(): void {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", { analytics_storage: "granted" });
  }
  injectGtagScript();
}

export function revokeAnalyticsConsent(): void {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", { analytics_storage: "denied" });
  }
}

export function trackPageView(path: string, title: string): void {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", { page_path: path, page_title: title });
  }
}

export function trackEvent(name: string, params?: Record<string, string | number | boolean>): void {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params ?? {});
  }
}
